<template>
  <div>
    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header -->
      <v-toolbar height="58" color="secondary" dark flat class="px-3">
        <div class="d-flex align-center">
          <v-icon left>mdi-tire-alert</v-icon>
          <span class="text-h6 font-weight-medium">
            {{ Titulo || "Neumáticos en SCRAP" }}
          </span>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-counter</v-icon>
            {{ ItemTotal || (Items ? Items.length : 0) }}
          </v-chip>
        </div>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-1 btn-circle-tooltip"
              icon
              dark
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="25" color="amber lighten-2"
                >mdi-alert-circle-outline</v-icon
              >
            </v-btn>
          </template>
          <span
            >Listado de neumáticos en baja definitiva / fuera de servicio</span
          >
        </v-tooltip>
      </v-toolbar>

      <div class="pa-4 pb-2">
        <!-- Barra de alerta informativa y leyenda -->
        <v-alert
          colored-border
          border="top"
          color="orange darken-3"
          elevation="2"
          icon="mdi-information-outline"
          class="orange lighten-5 rounded-lg mb-4 pa-3 alert-icon-leyenda"
          style="width: 100%"
        >
          <v-row dense class="align-center">
            <v-col cols="12">
              <div class="d-flex align-center flex-wrap pt-2">
                <span class="grey--text text--darken-4 body-2">
                  Los neumáticos que se listan aquí se encuentran en
                  <strong>SCRAP (baja definitiva / fuera de servicio)</strong>.
                </span>
              </div>
            </v-col>
            <!-- 1. Editar -->
            <v-col cols="12">
              <div class="d-flex align-center">
                <v-btn
                  height="22"
                  width="22"
                  color="blue lighten-2"
                  fab
                  x-small
                  dark
                  class="mr-2 elevation-1 flex-shrink-0"
                >
                  <v-icon x-small>mdi-pencil</v-icon>
                </v-btn>
                <div>
                  <span
                    class="blue--text text--darken-4 font-weight-bold text-caption mr-1"
                    >Editar:</span
                  >
                  <span
                    class="grey--text text--darken-4 text-caption font-weight-medium"
                    >Añadir el motivo de scrap y cargar las imágenes.</span
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </v-alert>

        <!-- Barra de Control: Búsqueda y Botones -->
        <div
          class="d-flex align-center justify-space-between flex-wrap gap-2 mb-3"
        >
          <div class="search-field flex-grow-1 mr-md-3">
            <v-text-field
              v-model="search"
              outlined
              dense
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              placeholder="Buscar por serie, marca, modelo, motivo..."
              class="rounded-lg"
            ></v-text-field>
          </div>

          <div class="d-flex align-center flex-wrap gap-2 mt-2 mt-md-0">
            <v-btn
              v-if="Excel"
              color="success"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg"
              @click="DescargarExcel()"
            >
              <v-icon left size="20">mdi-file-excel-box</v-icon>
              Exportar Excel
            </v-btn>

            <v-btn
              v-if="Crear"
              color="primary"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg ml-2"
              @click="nuevoItem()"
            >
              <v-icon left size="20">mdi-plus-circle</v-icon>
              Nuevo
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Tabla Responsiva -->
      <div class="table-responsive-wrapper">
        <v-data-table
          dense
          :headers="Cabecera"
          :items="Items"
          :items-per-page="10"
          :search="search"
          :loading="isLoading"
          class="elevation-0 modern-table"
          loading-text="Cargando neumáticos en scrap... Por favor, espere"
          no-data-text="No hay neumáticos en scrap para mostrar"
          :footer-props="{
            'items-per-page-text': 'Resultados por página:',
            'page-text': '{0}-{1} de {2}',
          }"
        >
          <!-- Opciones / Acciones -->
          <template v-slot:[`item.acciones`]="{ item }">
            <div class="d-flex align-center">
              <v-tooltip
                bottom
                v-if="
                  global._autorizacion_usuario(Permisos, $route.meta.id, ['3'])
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="24"
                    width="24"
                    color="blue lighten-2"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="editarItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar neumático</span>
              </v-tooltip>
            </div>
          </template>

          <!-- N° Serie destacado -->
          <template v-slot:[`item.num_serie`]="{ item }">
            <span class="font-weight-bold font-mono text--primary">
              {{ item.num_serie }}
            </span>
          </template>

          <!-- Motivo Scrap en Chip -->
          <template v-slot:[`item.motivo`]="{ item }">
            <v-chip
              v-if="item.motivo"
              x-small
              class="font-weight-bold text-uppercase px-2"
              color="amber lighten-4"
              text-color="amber darken-4"
            >
              {{ item.motivo }}
            </v-chip>
            <span v-else class="grey--text">-</span>
          </template>

          <!-- Remanente final -->
          <template v-slot:[`item.remanente_final`]="{ item }">
            <span
              v-if="item.remanente_final != null"
              class="font-weight-medium"
            >
              {{ item.remanente_final }} mm
            </span>
            <span v-else class="grey--text">-</span>
          </template>

          <!-- Remanente límite -->
          <template v-slot:[`item.remanente_limite`]="{ item }">
            <span
              v-if="item.remanente_limite != null"
              class="grey--text text--darken-2"
            >
              {{ item.remanente_limite }} mm
            </span>
            <span v-else class="grey--text">-</span>
          </template>

          <!-- Botón Ver Imagen -->
          <template v-slot:[`item.image`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="info"
                  height="26"
                  depressed
                  class="px-3 font-weight-medium text-caption text-none rounded-pill elevation-1"
                  dark
                  @click="verImagen(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left x-small>mdi-image-multiple-outline</v-icon>
                  Ver imagen
                </v-btn>
              </template>
              <span>Ver fotos del neumático</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-card>

    <!-- Modal Ver Imagen -->
    <Imagen
      ref="Imagen"
      :dialog="dialog_image"
      @dialog="dialog_image = $event"
      :Item="itemSelected"
    />

    <!-- Modal Editar -->
    <Editar
      ref="scrap"
      Titulo="Editar neumático en Scrap"
      :dialog="dialog_edit"
      @dialog="dialog_edit = $event"
      :Item="itemSelected"
      :MotivosScrap="MotivosScrap"
    />
  </div>
</template>

<script>
import exportFromJSON from "export-from-json";
import Imagen from "../scrap/imagen.vue";
import Editar from "../scrap/editar.vue";
import global from "@/global";
import { mapState } from "vuex";

export default {
  props: [
    "Titulo",
    "Cabecera",
    "Items",
    "ItemTotal",
    "Excel",
    "Crear",
    "MotivosScrap",
    "_loading",
    "loading",
  ],
  components: {
    Imagen,
    Editar,
  },
  data() {
    return {
      search: "",
      dialog_image: false,
      dialog_edit: false,
      itemSelected: {},
      global: global,
    };
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
    isLoading() {
      if (this.loading !== undefined) return this.loading;
      if (this._loading !== undefined) return this._loading;
      return false;
    },
  },
  methods: {
    editarItem(item) {
      item.fecha = item.fecha_scrap;
      this.itemSelected = item;
      this.dialog_edit = true;
    },

    verImagen(item) {
      this.itemSelected = item;
      this.dialog_image = true;
    },

    DescargarExcel() {
      const data = this.Items;
      const nombreArchivo = "download";
      const exportType = exportFromJSON.types.xls;
      exportFromJSON({ data, nombreArchivo, exportType });
    },

    nuevoItem() {
      this.$emit("nuevo");
    },
  },
};
</script>

<style scoped>
.modern-table {
  border-top: 1px solid #e2e8f0;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  white-space: nowrap;
  border-bottom: 2px solid #212121 !important;
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
  padding: 10px 14px !important;
  height: 42px !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th .v-data-table-header__icon {
  color: #ffffff !important;
}

.modern-table ::v-deep .v-data-table__progress th {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep .v-data-table__empty-wrapper td {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 8px 14px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
  transition: background-color 0.15s ease-in-out;
}

.modern-table ::v-deep .v-data-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.82rem;
  padding: 8px 16px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.scrap-banner {
  background-color: #fffbeb !important;
  border: 1px solid #fde68a !important;
  border-left: 4px solid #f59e0b !important;
}

.search-field {
  max-width: 360px;
  min-width: 220px;
}

@media (max-width: 768px) {
  .search-field {
    max-width: 100%;
    width: 100%;
  }
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out;
}

.action-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.font-mono {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier,
    monospace;
}

.alert-icon-leyenda ::v-deep .v-alert__wrapper {
  align-items: center !important;
}

.alert-icon-leyenda ::v-deep .v-alert__icon {
  align-self: center !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.gap-2 {
  gap: 8px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}
.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}
.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
